module.exports = __webpack_public_path__ + "img/Frente-37-00 off.d0ea9d9b.png";